import React from "react"
import { graphql } from "gatsby"

import { makeStyles } from '@material-ui/core/styles';
import Layout from "../components/layout"
import Seo from "../components/seo"

import GoogleMapComponent from '../components/map';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  title: {
    paddingBottom: theme.spacing(4),
  },
  topWapper: {
    backgroundColor: `white`,
  },
  newsWapper: {
    listStyle: `none`,
  },
  newsList: {
    paddingBottom: theme.spacing(4),
  },
}));

const BlogIndex = ({ data, location }) => {

  const siteTitle = data.site.siteMetadata?.title || `Title`
  const classes = useStyles();

  return (
    <Layout location={location} title={siteTitle} className={classes.root} isFooter={false}>
      <Seo title="アイランドウォッチ" />
      <GoogleMapComponent location={location} />
    </Layout>
  )
}

export default BlogIndex

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`
